import distance from "@turf/distance";
import * as opencage from "opencage-api-client";
export class OpenCageLocalProvider {
    constructor(apiKey, settings) {
        this.requestId = 1;
        this.apiKey = apiKey;
        this.settings = settings ?? { maxResults: 10 };
    }
    async forward(query, options) {
        const opencageQuery = { q: query.string, key: this.apiKey };
        if (query.location) {
            opencageQuery.proximity = `${query.location.lat},${query.location.lon}`;
        }
        if (typeof this.settings.bounds !== "undefined") {
            const bounds = this.settings.bounds;
            opencageQuery.bounds = `${bounds[0]},${bounds[1]},${bounds[2]},${bounds[3]}`;
        }
        if (typeof query.bounds !== "undefined") {
            const bounds = query.bounds;
            opencageQuery.bounds = `${bounds[0]},${bounds[1]},${bounds[2]},${bounds[3]}`;
        }
        if (typeof this.settings.countrycode !== "undefined") {
            opencageQuery.countrycode = this.settings.countrycode;
        }
        if (this.settings.language) {
            opencageQuery.language = this.settings.language;
        }
        if (query.string.length < 2) {
            return [];
        }
        const data = await opencage.geocode(opencageQuery);
        if (options?.signal?.aborted)
            throw new Error("Request cancelled");
        const results = [];
        data.results.forEach(r => {
            const result = {
                description: r.formatted,
                location: r.geometry,
                provider: "opencage",
                score: 20,
                type: r.components._type
            };
            // filter out irrelevant results.
            if (result.type == "parking" ||
                result.type == "fast_food")
                return;
            // calculate our own confidence levels.
            if (result.type == "city") {
                result.score = 95;
                // TODO: when far away, reduce score.
            }
            else if (result.type == "village") {
                result.score = 95;
                result.description = r.components.village;
            }
            else if (result.type == "railway") {
                result.score = 96;
                result.description = r.components.railway;
            }
            // replace results with the same description if score is better.
            const i = results.findIndex(x => x.description == result.description);
            if (i >= 0) {
                const existing = results[i];
                if (existing.score < result.score) {
                    results[i] = result;
                }
            }
            else {
                results.push(result);
            }
        });
        return results;
    }
    async reverse(l, options) {
        if (!l)
            return [];
        const data = await opencage
            .geocode({ q: `${l.lat},${l.lng}`, key: this.apiKey });
        return [{
                description: data.results[0].formatted,
                location: data.results[0].geometry,
                distance: distance([l.lng, l.lat], [data.results[0].geometry.lng, data.results[0].geometry.lat]) * 1000
            }];
    }
}
